import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { userService } from './userService';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { restURL } from '../Models/restURL';
import { mdlPayloadRequest } from '../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../Models/mdlPayloadResponse';
import { mdlAPIRes } from '../Models/mdlAPIRes';
import { EncryptionService } from './EncryptionService';
import { environment } from '../environments/environment';
import { EncryptionKeyService } from './EncryptionKeyService';

const EXCEL_EXTENSION = '.xlsx';


@Injectable()
// @Injectable({
//   providedIn: 'root'
// })
export class APIService {
  public apiUrl: restURL = new restURL();
  constructor(private router: Router, private EncriptService: EncryptionService, private userInfo: userService, private http: HttpClient, private encryptionKeyService:EncryptionKeyService) { }

  async ConnectAPI(Entpoint: string, Request: any): Promise<any> {
    if (!environment.St.StatusDesc) {
      await this.encryptionKeyService.GetHomeDropDowns();
    }
    
    let ApiRes: mdlAPIRes = new mdlAPIRes();
    let Res: any;
    try {
      let objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
      let objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

      objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(Request));

      await this.http.post<mdlPayloadResponse>(this.apiUrl.baseURL + Entpoint, objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
        objPayloadResponse = result;
        Res = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(objPayloadResponse.PayloadResponse)));
        ApiRes.StatusCode = "S";
      },
        (error) => {
          ApiRes.StatusCode = "F";
          ApiRes.StatusDesc = error.message;
          if (error.message.includes('401 OK') || error.message.includes('401 Unauthorized')) {
            ApiRes.StatusDesc = "Session Expired Please Login Again";
            Swal("Session Expired Please Login Again", "", "warning")
            this.router.navigate(['/Login']);
          }
        });
    }
    catch (error) {
      ApiRes.StatusCode = "F";
      ApiRes.StatusDesc = error.message;
    }
    return [ApiRes, Res];
  }

  async ConnectAPIWithoutEncRes(Entpoint: string, Request: any): Promise<any> {
    if (!environment.St.StatusDesc) {
      await this.encryptionKeyService.GetHomeDropDowns();
    }
    
    let ApiRes: mdlAPIRes = new mdlAPIRes();
    let Res: any;
    try {
      let objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
      objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(Request));

      await this.http.post<any>(this.apiUrl.baseURL + Entpoint, objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
        Res = result;
        ApiRes.StatusCode = "S";
      },
        (error) => {
          ApiRes.StatusCode = "F";
          ApiRes.StatusDesc = error.message;
          if (error.message.includes('401 OK') || error.message.includes('401 Unauthorized')) {
            ApiRes.StatusDesc = "Session Expired Please Login Again";
            Swal("Session Expired Please Login Again", "", "warning")
            this.router.navigate(['/Login']);
          }
        });
    }
    catch (error) {
      ApiRes.StatusCode = "F";
      ApiRes.StatusDesc = error.message;
    }
    return [ApiRes, Res];
  }

  async ConnectGetAPIWithoutEncRes(Entpoint: string, Request: any): Promise<any> {
    if (!environment.St.StatusDesc) {
      await this.encryptionKeyService.GetHomeDropDowns();
    }
    
    let ApiRes: mdlAPIRes = new mdlAPIRes();
    let Res: any;
    try {
      let objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
      objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(Request));

      await this.http.get<any>(this.apiUrl.baseURL + Entpoint, this.userInfo.getHttpOptions()).toPromise().then((result) => {
        Res = result;
        ApiRes.StatusCode = "S";
      },
        (error) => {
          ApiRes.StatusCode = "F";
          ApiRes.StatusDesc = error.message;
          if (error.message.includes('401 OK') || error.message.includes('401 Unauthorized')) {
            ApiRes.StatusDesc = "Session Expired Please Login Again";
            Swal("Session Expired Please Login Again", "", "warning")
            this.router.navigate(['/Login']);
          }
        });
    }
    catch (error) {
      ApiRes.StatusCode = "F";
      ApiRes.StatusDesc = error.message;
    }
    return [ApiRes, Res];
  }


  


  
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/api.service.ts